import {PageRequest} from '../../lib/core/common/dto/PageRequest';


export class ChartPageRequest extends PageRequest {

  id: number | undefined;

  setId(id: number | undefined): ChartPageRequest {
    this.id = id;
    return this;
  }

}
